var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7701_3579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.5909,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7701_3579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7058 13.2866C9.61208 13.2866 8.67581 12.8972 7.89703 12.1184C7.11805 11.3394 6.72856 10.4031 6.72856 9.3093C6.72856 8.21555 7.11805 7.27929 7.89703 6.5005C8.67581 5.72152 9.61208 5.33203 10.7058 5.33203C11.7996 5.33203 12.7359 5.72152 13.5146 6.5005C14.2936 7.27929 14.6831 8.21555 14.6831 9.3093C14.6831 10.4031 14.2936 11.3394 13.5146 12.1184C12.7359 12.8972 11.7996 13.2866 10.7058 13.2866ZM2.18311 20.2141V19.4141C2.18311 18.8577 2.33424 18.3424 2.63651 17.8681C2.93879 17.3939 3.34276 17.0293 3.84845 16.7744C4.97155 16.2238 6.1046 15.8108 7.24759 15.5354C8.39059 15.2601 9.54333 15.1224 10.7058 15.1224C11.8683 15.1224 13.0211 15.2601 14.1641 15.5354C15.3071 15.8108 16.4401 16.2238 17.5632 16.7744C18.0689 17.0293 18.4729 17.3939 18.7752 17.8681C19.0774 18.3424 19.2286 18.8577 19.2286 19.4141V20.2141C19.2286 20.6933 19.0607 21.1009 18.7249 21.4369C18.3891 21.7727 17.9815 21.9406 17.5021 21.9406H3.90953C3.43017 21.9406 3.02259 21.7727 2.6868 21.4369C2.351 21.1009 2.18311 20.6933 2.18311 20.2141ZM3.88765 20.236H17.524V19.4141C17.524 19.184 17.4573 18.971 17.324 18.7749C17.1907 18.5791 17.0097 18.4192 16.7811 18.2954C15.8019 17.8132 14.8037 17.4478 13.7862 17.1994C12.7686 16.9511 11.7418 16.8269 10.7058 16.8269C9.66985 16.8269 8.64305 16.9511 7.62544 17.1994C6.60801 17.4478 5.60972 17.8132 4.63055 18.2954C4.40195 18.4192 4.22098 18.5791 4.08765 18.7749C3.95432 18.971 3.88765 19.184 3.88765 19.4141V20.236ZM10.7058 11.582C11.3308 11.582 11.8659 11.3595 12.3109 10.9144C12.756 10.4693 12.9786 9.9343 12.9786 9.3093C12.9786 8.6843 12.756 8.14927 12.3109 7.70419C11.8659 7.25911 11.3308 7.03658 10.7058 7.03658C10.0808 7.03658 9.54579 7.25911 9.10072 7.70419C8.65564 8.14927 8.43311 8.6843 8.43311 9.3093C8.43311 9.9343 8.65564 10.4693 9.10072 10.9144C9.54579 11.3595 10.0808 11.582 10.7058 11.582Z",
    fill: "#2B2B2B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.07d80027ad353db1ce037fe455b4b8fa.svg";
export { ForwardRef as ReactComponent };